import { DurationUnit } from '../../../../../types/durationUnit'

export const durationUnitToRecurringPeriodTranslationKey: Record<DurationUnit, string> = {
  D: 'legacy_recurring_invoices_list.recurring_period.d',
  M: 'legacy_recurring_invoices_list.recurring_period.m',
  W: 'legacy_recurring_invoices_list.recurring_period.w',
  Y: 'legacy_recurring_invoices_list.recurring_period.y',
}
